import { Component } from '@angular/core';
import { MdDialog, MdDialogRef } from '@angular/material';

@Component({
    selector: 'modal-box',
    templateUrl: './modal-box.component.html',
    styleUrls: ['./modal-box.component.css']
})

/**
 * Component to show the large message.
 *
 * @author pankaj.khurana@vernuso.com (Pankaj Khurana)
 */
export class ModalBoxComponent {

    message: string = '';

    constructor(public dialogRef: MdDialogRef<any>) {}
}



// WEBPACK FOOTER //
// ./src/app/shared/components/modalbox/modal-box.component.ts